  
  .form-group {
    margin-bottom: 20px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }
  
  input[type="text"],
  input[type="password"],
  input[type="number"],
  select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  input[type="file"] {
    width: 100%;
    padding: 8px 0;
  }
  
  input[type="checkbox"] {
    margin-right: 8px;
  }
  
  fieldset {
    border: 1px solid #ddd;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    width: 600px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  
  legend {
    padding: 0 10px;
    font-weight: bold;
  }
  
  /* Required field indicator */
  label[for]:after {
    content: " *";
    color: #ff0000;
  }

.form-box {
  margin: 20px;
}
.form-box ix-input,ix-upload {
  width: 400px; 
}

.not-valid {
  border: 1px solid red !important;
}
